module.exports = __webpack_public_path__ + "static/media/mini.1557b6ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/data/carImages/远程GLR增程式厢式车/mini.png
// module id = 705
// module chunks = 0